import './Features.css'
import React from 'react'

export default ({ features }) =>
    <section className='features'>
        <div className='container'>
            {features.map(({ title, content, image }, index) => 
                <div className={`feature`} key={index}>
                    {image.publicURL && <img src={image.publicURL} alt={title} />}
                    {title && <h3>{title}</h3>}
                    {content && <p>{content}</p>}
                </div>
            )}
        </div>
    </section>



// WEBPACK FOOTER //
// ./src/components/Features.js